/**
 * Normalize servings from recipe metadata or UI state for cook-session API bodies.
 * Backend expects a positive integer (or omit the field).
 */
export function normalizeServingsForCookSession(value, fallback = 4) {
  if (value == null || value === '') return fallback
  if (typeof value === 'number' && Number.isFinite(value)) {
    const n = Math.round(value)
    return n > 0 ? Math.min(n, 99) : fallback
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return fallback
    const match = trimmed.match(/\d+/)
    if (match) {
      const n = parseInt(match[0], 10)
      return n > 0 ? Math.min(n, 99) : fallback
    }
  }
  return fallback
}

/** Best-effort message from a failed fetch Response. */
export async function readApiErrorDetail(response, fallback) {
  try {
    const data = await response.json()
    const { detail } = data
    if (typeof detail === 'string' && detail.trim()) return detail
    if (Array.isArray(detail) && detail.length > 0) {
      return detail
        .map((entry) => {
          if (typeof entry === 'string') return entry
          if (entry && typeof entry.msg === 'string') return entry.msg
          return JSON.stringify(entry)
        })
        .join('; ')
    }
  } catch {
    // ignore parse errors
  }
  return fallback
}
